//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetOperationLogList } from '@/api/yytapi';
export default {
  name: 'OperationLog',
  data: function data() {
    return {
      tableData: {},
      tableFrom: {
        page: 1,
        limit: 20,
        userName: ''
      },
      listLoading: false,
      dialogVisible: false,
      currentRow: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        page: this.tableFrom.page,
        limit: this.tableFrom.limit
      };
      if (this.tableFrom.userName) params.userName = this.tableFrom.userName;
      GetOperationLogList(params).then(function (res) {
        _this.tableData = res || {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    onSearch: function onSearch() {
      this.tableFrom.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.tableFrom = {
        page: 1,
        limit: 20,
        userName: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.tableFrom.page = 1;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    userTypeText: function userTypeText(type) {
      var map = {
        0: '系统',
        1: '用户',
        2: '管理员'
      };
      return map[type] || '-';
    },
    userTypeTag: function userTypeTag(type) {
      var map = {
        0: 'info',
        1: '',
        2: 'warning'
      };
      return map[type] || 'info';
    },
    onViewDetail: function onViewDetail(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    formatJson: function formatJson(str) {
      if (!str) return '-';
      try {
        var obj = typeof str === 'string' ? JSON.parse(str) : str;
        return JSON.stringify(obj, null, 2);
      } catch (_unused) {
        return str;
      }
    }
  }
};